module.exports = __webpack_public_path__ + "img/ppa.16396382.jpg";